// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__zeUhT","errors":"Errors_errors__JAIZ-"};